<template>
  <div ref="tableBox">
    <div class="filter-list">
      <div class="filter-item">
        <div class="item-label">
          状态
        </div>
        <div class="item-component">
          <div class="el-select-wrapper">
            <el-select v-model="status.value" placeholder="请选择" clearable @change="buildData">
              <el-option v-for="item in status.options" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="tableData">
      <el-table-column type="index" width="20px" label="#"></el-table-column>
      <el-table-column property="typeText" label="类型" width="80px"></el-table-column>
      <el-table-column property="summary" label="主题" min-width="200px" :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" target="_blank"
                   :href="$util.buildSmsActivityDetailUrl(scope.row.actId)">
            {{ scope.row.summary }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column property="description" label="详情描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventTypeText" label="事件类型" width="120px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventReasonText" label="事件原因" width="80px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventLevelText" label="严重等级" width="80px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="safetyMeasures" label="安全措施" width="80px"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="statusText" label="状态" width="65px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="reportTime" label="报告时间" width="120px" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <div class="page-wrapper">
      <el-pagination background layout="prev, pager, next" :total="page.total" :current-page.sync="page.num"
                     :page-size.sync="page.size">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";

export default {
  props: {
    symptom: String,
    company: String,
    year: Number,
    month: Number,
  },
  data() {
    return {
      //表格数据
      tableData: [],
      //分页
      page: {
        num: 1,
        size: 5,
        total: null,
      },
      //状态
      status: {
        options: [{
          code: "FINISH",
          name: "结案"
        }, {
          code: "CLOSED",
          name: "关闭"
        }, {
          code: "INPROGRESS",
          name: "处理中"
        }],
        value: null
      },
    }
  },
  mounted() {
    this.buildData();
  },
  methods: {
    /**
     * 构建表格数据
     */
    buildData() {
      getRequest(`/result/symptom/detail/${this.year}`, {
        symptom: this.symptom,
        company: this.company,
        month: this.month,
        status: this.status.value,
        pageNum: this.page.num,
        pageSize: this.page.size
      }, this.$refs.tableBox).then(res => {
        this.tableData = res.data.records
        this.page.total = res.data.total
      })
    },
    initPage() {
      this.page.num = 1;
    },
  },
  watch: {
    symptom() {
      this.buildData();
    },
    company() {
      this.buildData();
    },
    year() {
      this.buildData();
    },
    month() {
      this.buildData();
    },
    "page.num"() {
      this.buildData();
    }
  }
}
</script>

<style scoped lang="less">
.filter-list {
  display: flex;
  margin: 5px 0 10px 0;

  .filter-item {
    display: flex;
    align-items: center;

    .item-label {

    }

    .item-component {
      margin-left: 10px;
    }
  }

  .filter-item:not(:first-child) {
    margin-left: 10px;
  }
}

.page-wrapper {
  text-align: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/result/SymptomDetail.vue